export function canAccessTubeLaser(user = {}) {
    const groups = Array.isArray(user.groups) ? user.groups : [];
    return user.admin === true || groups.includes("Amministrazione");
}
